import {useDispatch, useSelector} from "react-redux";
import {selectPortfoliosWithUserUpdates} from "../../../store/slices/portfolios.slice";
import React, {useCallback} from "react";
import {
    fetchDetailedPortfolioObjects,
    updatePortfolioDetails,
    updateUserPortfolioData
} from "../../../api/portfolioApi";
import {message} from "antd";


const usePortfoliosCollection = ()=>{
    const dispatch = useDispatch();
    const items = useSelector(selectPortfoliosWithUserUpdates);

    const formattedPortfolios = React.useMemo(() => {
        if (!items?.length) return [];
        return items
            .filter(portfolio => portfolio?._user?.hasOwnProperty?.('in_use'))
            .map((portfolio) => ({
                ...portfolio,
                inceptionDate: new Date(portfolio.inception_date * 1000).toLocaleDateString(),
            }));
    }, [items]); // Remove JSON.stringify, add proper null checks


    const clientFilteredPortfolios = React.useMemo(() => {
        return items.filter(portfolio => portfolio?.attr?.category==='custom');
    }, [items]);


    const toggleFavorite = useCallback((portfolioId, isStarred) => {
      return dispatch(updateUserPortfolioData({
        portfolioID: portfolioId,
        updateFields: { in_use: isStarred }
      })).catch(() => {
        message.error('Failed to update portfolio status');
      });
    }, [dispatch]);

    // Edit action
    const handleEdit = useCallback((portfolioId) => {
      if (!portfolioId) return;
      return dispatch(fetchDetailedPortfolioObjects([portfolioId]))
        .then(() => ({
          type: 'EDIT_SUCCESS',
          portfolioId
        }))
        .catch(() => {
          message.error('Failed to fetch portfolio details');
          return { type: 'EDIT_ERROR' };
        });
    }, [dispatch]);

    // Update portfolio details
    const handleUpdatePortfolioDetails = useCallback((payload) => {
      return dispatch(updatePortfolioDetails({
        data: payload.data,
        portfolioId: payload.portfolioId
      }))
      .then((response) => {
        if (response?.meta?.requestStatus === 'fulfilled') {
          message.success('Portfolio updated successfully!');
          return true;
        }
        message.error('Failed to update the portfolio.');
        return false;
      })
      .catch(() => {
        message.error('Error updating portfolio.');
        return false;
      });
    }, [dispatch]);


    return {
        formattedPortfolios,
        clientFilteredPortfolios,
        handleEdit,
        handleUpdatePortfolioDetails,
        toggleFavorite,

    }

}

export default usePortfoliosCollection;